// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CustomAvatarPage from "./pages/CustomAvatarPage";
import HomePage from "./pages/HomePage";
import StudioPage from "./pages/StudioPage";
import JokePage from "./pages/JokePage";
import UploadJokesPage from "./pages/UploadJokesPage";
import YooCreatePage from "./pages/YooCreatePage";
import YooChatPage from "./pages/YooChatPage";
import SubscriptionPage from "./pages/SubscriptionPage";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen">
        <Routes>
          {/* <Route path="/" element={<HomePage />} /> */}
          <Route path="/custom-avatar" element={<CustomAvatarPage />} />
          <Route path="/" element={<StudioPage />} />
          {/* <Route path="/studio" element={<StudioPage />} /> */}
          <Route path="/joke" element={<JokePage />} />
          <Route path="/upload-jokes" element={<UploadJokesPage />} />
          <Route path="/yoo-create" element={<YooCreatePage />} />
          <Route path="/yoo-chat" element={<YooChatPage />} />
          <Route path="/subscribe" element={<SubscriptionPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
